/**
 * Protected Route component - redirects to login if not authenticated
 * Also sets up auth token getter for API calls
 */

import { useAuth0 } from '@auth0/auth0-react'
import { ReactNode } from 'react'
import Login from '@/pages/Login'
import { useAuth } from '@/hooks/useAuth'
import { setAuthTokenGetter } from '@/services/api/client'

interface ProtectedRouteProps {
  children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth0()
  const { getToken } = useAuth()

  // Set token getter for API client immediately when authenticated
  // Do this synchronously to avoid race conditions with API calls
  if (isAuthenticated && getToken) {
    setAuthTokenGetter(getToken)
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Đang xác thực...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Login />
  }

  return <>{children}</>
}

